
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaionlinecabbooking() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Online Cab Booking',
        heading: 'Skyline Cabs: Pune to Mumbai Online Cab Booking',
        headingDescription: 'Skyline Cabs makes your travel easy with convenient Pune to Mumbai Online Cab Booking. Enjoy the simplicity of booking your ride online anytime, anywhere. Whether it is a business trip, airport transfer, or a quick getaway, our user-friendly booking platform ensures a seamless experience. With well-maintained vehicles and professional drivers, Skyline Cabs guarantees a comfortable and timely journey from Pune to Mumbai. Book your ride today and travel with ease and confidence.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Pune to Mumbai Online Cab Booking Price",
      "description": "Check real-time pricing and book your cab online with Skyline Cabs for your Pune to Mumbai journey. We offer upfront and competitive rates with no hidden charges. Book in advance or on-demand with instant confirmation through our online portal or WhatsApp support."
    },
    {
      "name": "Pune to Mumbai Return Cab Fare",
      "description": "Skyline Cabs offers flexible return cab packages for Pune to Mumbai travel. Whether you're coming back the same day or staying overnight, our round-trip fares are affordable and include driver charges, fuel, and tolls."
    },
    {
      "name": "Pune to Mumbai Taxi Fare",
      "description": "Our Pune to Mumbai taxi fare structure is transparent and budget-friendly. Skyline Cabs provides detailed fare breakdowns based on your preferred vehicle and travel type—one-way, round trip, or airport drop."
    },
    {
      "name": "Pune to Mumbai Affordable Fare",
      "description": "Looking for budget-friendly travel options? Skyline Cabs offers affordable cab fares for Pune to Mumbai with economy sedans and Ertiga options that make your travel easy on the wallet and high on comfort."
    },
    {
      "name": "Pune Mumbai Online Innova Booking",
      "description": "Book an Innova online with Skyline Cabs for your Pune to Mumbai journey. Our seamless booking system ensures availability, confirmed fares, and a hassle-free experience for family, corporate, or group travel."
    },
    {
      "name": "Pune Mumbai Online Ertiga Booking",
      "description": "Reserve your Ertiga cab online for Pune to Mumbai with Skyline Cabs. The Ertiga offers spacious seating, a smooth ride, and great value for money. Ideal for small groups or families seeking a budget-friendly yet comfortable journey."
    },
    {
      "name": "Pune to Mumbai Sedan Cab Booking Online",
      "description": "Skyline Cabs makes it easy to book a sedan online for your Pune to Mumbai trip. Choose from Dzire, Amaze, or similar models—perfect for solo or couple travelers who want a clean, quiet, and smooth ride."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Travel from Pune to Mumbai in comfort and style with Skyline Cabs’ Ertiga cabs. Perfect for families and groups, the Ertiga combines space and fuel-efficiency, making it one of the most popular intercity travel options."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Book a premium Innova cab for your Pune to Mumbai trip with Skyline Cabs. Known for comfort and reliability, the Innova is ideal for long-distance journeys and offers ample space for luggage and passengers."
    },
    {
      "name": "Pune to Mumbai Online Innova Crysta Booking",
      "description": "Enjoy a luxurious ride from Pune to Mumbai with Skyline Cabs’ Innova Crysta online booking. The Crysta offers extra comfort and elegance—ideal for corporate trips, VIP pickups, and premium family travel."
    },
    {
      "name": "Toyota Innova Crysta Car Hire Pune",
      "description": "Hire a Toyota Innova Crysta from Pune for your Mumbai trip with Skyline Cabs. Our Crysta fleet is top-of-the-line, featuring plush interiors and excellent ride quality, perfect for both business and leisure travelers."
    },
    {
      "name": "Toyota Innova Ertiga Car Booking",
      "description": "Skyline Cabs offers easy online booking for Toyota Innova and Ertiga models. Select the vehicle that suits your group size and budget, and travel from Pune to Mumbai in comfort, safety, and style."
    },
    {
      "name": "Pune to Mumbai Sedan Cab Service Online Booking",
      "description": "Skyline Cabs provides seamless online booking for sedan cab services between Pune and Mumbai. Choose from economical options like Dzire or Amaze, perfect for solo, couple, or business travel needs."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Make your travel plan efficient with Skyline Cabs’ round trip service from Pune to Mumbai. Book online and enjoy round-trip discounts, flexible return options, and top-rated driver support for your entire journey."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Skyline Cabs is a top-rated choice for Pune to Mumbai cab services. With reliable vehicles, courteous drivers, and 24/7 booking options, we guarantee a smooth and secure travel experience every time."
    },
    {
      "name": "Pune to Mumbai 24x7 Online Cab Booking",
      "description": "Book your Pune to Mumbai cab anytime, anywhere with Skyline Cabs’ 24x7 online booking platform. Whether it's a last-minute airport drop or a scheduled business trip, we’re available round-the-clock for your convenience."
    },
    {
      "name": "Pune to Mumbai Airport Cab Service",
      "description": "Skyline Cabs offers prompt and reliable cab service from Pune to Mumbai Airport. Enjoy timely pickups, experienced drivers, and fixed fares for all airport transfers, including T1, T2, and T3 terminals."
    },
    {
      "name": "Pune Airport to Mumbai Cab",
      "description": "Need a cab from Pune Airport to Mumbai? Skyline Cabs provides smooth and affordable rides directly from Pune Airport to any location in Mumbai. Choose from sedan, Ertiga, or Innova based on your travel needs."
    },
    {
      "name": "Pune Airport to Mumbai Airport Cab",
      "description": "Skyline Cabs offers direct transfers from Pune Airport to Mumbai Airport. Book online and enjoy a comfortable and punctual inter-airport journey with drivers who know the best routes and peak-time shortcuts."
    },
    {
      "name": "Pune to Mumbai Skyline Cabs Online Cab Booking",
      "description": "Skyline Cabs makes your Pune to Mumbai travel hassle-free with fast and reliable online cab booking. Get live availability, instant fare estimates, and real-time driver tracking—all from your phone or laptop."
    }
  ],

  "tableData": [
    ["Pune to Mumbai Online Cab Booking Price", "-Pune to Mumbai Return Cab Fare"],
    ["Pune to Mumbai Taxi Fare", "-Pune to Mumbai Affordable Fare"],
    ["Pune Mumbai Online Innova Booking", "-Pune Mumbai Online Ertiga Booking"],
    ["Pune to Mumbai Sedan Cab Booking Online", "-Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "-Pune to Mumbai Online Innova Crysta Booking"],
    ["Toyota Innova Crysta Car Hire Pune", "-Toyota Innova Ertiga Car Booking"],
    ["Pune to Mumbai Sedan Cab Service Online Booking", "-Pune to Mumbai Cab Round Trip"],
    ["Best Cab Service Pune to Mumbai", "-Pune to Mumbai 24x7 Online Cab Booking"],
    ["Pune to Mumbai Airport Cab Service", "-Pune Airport to Mumbai Cab"],
    ["Pune Airport to Mumbai Airport Cab", "-Pune to Mumbai Skyline Cabs Online Cab Booking"]
  ],

  whychoose: [
    {
        "WhyChooseheading": "Seamless Pune to Mumbai Online Cab Booking",
        "WhyChoosedescription": "Skyline Cabs makes booking your Pune to Mumbai cab easier than ever. With just a few clicks on our website or app, you can schedule your ride in seconds—no waiting, no paperwork, just quick and hassle-free online cab booking at your convenience."
    },
    {
        "WhyChooseheading": "Instant Confirmation and Real-Time Updates",
        "WhyChoosedescription": "Once your booking is complete, you receive instant confirmation with all ride details. Track your cab in real-time, receive driver contact info, and stay updated every step of the way from Pune to Mumbai."
    },
    {
        "WhyChooseheading": "User-Friendly Interface for Fast Booking",
        "WhyChoosedescription": "Our platform is designed to be simple and intuitive. Whether you're booking from a phone, tablet, or desktop, our online cab booking system ensures a smooth experience, even for first-time users."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Flexibility",
        "WhyChoosedescription": "We offer various secure online payment options including UPI, wallets, debit/credit cards, and net banking. Prefer to pay later? We also support cash payments at the end of the trip—your convenience, your choice."
    },
    {
        "WhyChooseheading": "24/7 Booking Access Anytime, Anywhere",
        "WhyChoosedescription": "Need a cab at midnight or for an early morning pickup? No problem. Skyline Cabs’ online booking platform is available 24/7, so you can book your Pune to Mumbai ride whenever it suits you best, from anywhere."
    },
    {
        "WhyChooseheading": "Verified Drivers and Safe Online Booking",
        "WhyChoosedescription": "Safety is always a priority with Skyline Cabs. All drivers are background-checked and trained. Our secure online booking ensures your personal and payment information is always protected."
    },
    {
        "WhyChooseheading": "Transparent Fare Estimates Before You Book",
        "WhyChoosedescription": "Our online system shows you fare estimates based on your pickup, drop location, and vehicle preference before you confirm. No guesswork, no surprises—just clear, upfront pricing every time."
    },
    {
        "WhyChooseheading": "Easy Modifications and Cancellations",
        "WhyChoosedescription": "Plans changed? You can easily modify or cancel your booking online with minimal hassle. Skyline Cabs provides flexible options and fair cancellation policies, so you're always in control of your travel."
    }
]







    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a Pune to Mumbai cab online with Skyline Cabs?',
            answer:
                'Booking online is quick and easy. Just visit our website or download the Skyline Cabs app. Enter your pickup and drop location, choose your preferred vehicle, and confirm the booking in a few clicks.',
        },
        {
            id: 2,
            question: 'Is it safe to book a cab online for Pune to Mumbai travel?',
            answer:
                'Absolutely. Skyline Cabs uses secure platforms for online booking and payment. Our drivers are verified, and every trip is GPS-tracked to ensure passenger safety.',
        },
        {
            id: 3,
            question: 'Can I choose my preferred vehicle while booking online?',
            answer:
                'Yes, during the online booking process, you can choose from a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars, depending on your comfort and budget.',
        },
        {
            id: 4,
            question: 'Do I need to create an account for online cab booking?',
            answer:
                'Creating an account is optional but recommended for faster bookings, managing your rides, and accessing exclusive discounts. You can also book as a guest without an account.',
        },
        {
            id: 5,
            question: 'Can I modify or cancel my Pune to Mumbai cab booking online?',
            answer:
                'Yes, you can easily modify or cancel your booking through our app or website. Flexible policies apply, and there are no cancellation charges if done within the permitted window.',
        },
        {
            id: 6,
            question: 'Will I get an instant confirmation after booking online?',
            answer:
                'Yes, once you complete the booking, you will receive an instant confirmation via SMS and email, along with driver and vehicle details before your trip begins.',
        },
        {
            id: 7,
            question: 'Are there any offers available for online bookings?',
            answer:
                'Yes, we regularly offer discounts and promo codes for online bookings. Check our website or app during the booking process to apply any available offers.',
        },
        {
            id: 8,
            question: 'What payment methods are available for online cab bookings?',
            answer:
                'We support UPI, net banking, debit/credit cards, and wallets. You can also opt for cash payment at the end of your trip if preferred.',
        },
        {
            id: 9,
            question: 'Can I book a cab online for immediate pickup from Pune to Mumbai?',
            answer:
                'Yes, depending on availability, you can book a cab for immediate pickup. For best service, we recommend booking at least 1–2 hours in advance.',
        },
        {
            id: 10,
            question: 'Why should I use Skyline Cabs for online cab booking from Pune to Mumbai?',
            answer:
                'Skyline Cabs offers a seamless online booking experience, 24/7 customer support, professional drivers, and competitive rates. We make intercity travel simple, reliable, and comfortable.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Arvind Joshi",
            rating: 5,
            review: "Booked online through Skyline’s app and the experience was flawless. The interface is simple, the fare was fair, and I got updates every step of the way. Truly hassle-free travel from Pune to Mumbai!"
        },
        {
            name: "Miss. Tanya Kulkarni",
            rating: 4,
            review: "I loved how smooth the online booking was. Got an instant confirmation and the cab was on time. Only suggestion would be to add more vehicle pictures in the app. Otherwise, everything was perfect!"
        },
    ];
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Online Cab Booking",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-online-cab-booking.jpg",
  "description": "Book Pune to Mumbai cab online with Skyline Cabs for a smooth, secure, and affordable journey. Choose AC sedans, SUVs, or premium cars with professional drivers – available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8297"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1250",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-online-cab-booking"
  }
};



      
  



    return (
        <div>
   <Helmet>
  <title>Pune to Mumbai Online Cab Booking | Safe & 24/7 Service | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai cab online with Skyline Cabs for a smooth, secure, and affordable journey. Choose AC sedans, SUVs, or premium cars with professional drivers – available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Online Cab Booking, Book Cab Pune to Mumbai Online, Online Taxi Service Pune Mumbai, AC Cab Booking Pune to Mumbai, SUV Cab Online Pune to Mumbai, Pune Mumbai One Way Cab Online, 24/7 Cab Booking Pune Mumbai, Skyline Cabs Pune to Mumbai, Online Car Hire Pune to Mumbai, Affordable Online Taxi Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/7.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaionlinecabbooking;